import { thumbnail, errorPlaceholder } from "../../../functions/thumbnail";

export default {
  props: {
    data: Object,
  },
  methods: {
    thumb(item, big = false) {
      return thumbnail(item, big);
    },
    onError(e) {
      errorPlaceholder(e);
    },
  },
};
